module.exports = __webpack_public_path__ + "media/images/let-you-screen/fb-icon-f41f5a69b7c78432ce5eb5a07ea23fc2.svg";